import { defineMessages } from 'react-intl';

const namespace = 'crdf_journeys_forms_addressForm';

export default defineMessages({
  streetLabel: {
    id: `${namespace}_streetLabel`,
    defaultMessage: 'Ulice a č.p.',
  },
  cityLabel: {
    id: `${namespace}_cityLabel`,
    defaultMessage: 'Město',
  },
  postalCodeLabel: {
    id: `${namespace}_postalCodeLabel`,
    defaultMessage: 'PSČ',
  },
  countryLabel: {
    id: `${namespace}_countryLabel`,
    defaultMessage: 'Stát',
  },
  hasDifferentContactAddressLabel: {
    id: `${namespace}_hasDifferentContactAddressLabel`,
    defaultMessage: 'Nastavit jinou kontaktní adresu',
  },
  backButtonLabel: {
    id: `${namespace}_backButtonLabel`,
    defaultMessage: 'Krok zpět',
  },
  continueButtonLabel: {
    id: `${namespace}_continueButtonLabel`,
    defaultMessage: 'Pokračovat',
  },
  contactAddressTitle: {
    id: `${namespace}_contactAddressTitle`,
    defaultMessage: 'Kontaktní adresa',
  },
});
